import { StarIcon } from "@phosphor-icons/react"

export default StarIcon
